import React, {useState} from 'react'
import ThemeList from "./theme-list";
import ThemeDetail from "./theme-detail";

const ThemeDashboard = () => {
    const [selectedTheme, setSelectedTheme] = useState(null);
    const [selectedThemeRemoved, setSelectedThemeRemoved] = useState(false);

    return (
        <>

            <div className="page-container dashboard-container">
                <div className="items-center justify-start w-1/3 p-8 mb-28">
                    <div className="flex justify-between mb-6">
                        <div className="text-xl">
                            Themes
                        </div>

                        <div className="float-right">
                            <a href="/themes/add-themes" className="button-medium">
                                <span>Add New Themes</span>
                            </a>
                        </div>
                    </div>

                    <ThemeList
                        setSelectedThemeRemoved={setSelectedThemeRemoved}
                        selectedThemeRemoved={selectedThemeRemoved}
                        selectedTheme={selectedTheme}
                        setSelectedTheme={setSelectedTheme}/>
                </div>

                <div className="items-center justify-start w-2/3 pb-16 mr-8 my-8">
                    <ThemeDetail
                        setSelectedThemeRemoved={setSelectedThemeRemoved}
                        selectedTheme={selectedTheme}
                        setSelectedTheme={setSelectedTheme}/>
                </div>
            </div>

        </>
    )
}

export default ThemeDashboard
